<template>
  <button
    type="button"
    class="rounded-full flex items-center justify-center bg-brand-bgdivider-20 text-basics-primary text-lg hover:text-basics-tertiary-60"
    :class="{
      'bg-brand-primary': !disabled && isActive,
      'text-basics-primary': !disabled && isActive,
      'text-basics-tertiary-60 b border-basics-tertiary-60': disabled,
      'p-6u': !size || size === 'md',
      'p-10u': size === 'lg',
      'p-15u': size === 'xl',
    }"
    :disabled="disabled"
    @click="(e) => emit('click', e)"
  >
    <Icon :icon="icon" class="size-20u" />
  </button>
</template>

<script setup lang="ts">
import { Icon } from "@iconify/vue";

const emit = defineEmits<{
  click: [MouseEvent];
}>();

defineProps<{
  icon: string;
  size?: "md" | "lg" | "xl";
  isActive?: boolean;
  disabled?: boolean;
}>();
</script>
